<template>
  <div style="height: 100%;" class="d-flex flex-column justify-center align-center">
    <img src="/img/links-empty.svg">
    <strong class="mt-3">Crie seu primeiro link</strong>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

</style>